import React from "react";
import "./footer.css";
import { CONTACT_EMAIL } from "../../../Constants/Home";
import { useTranslation } from "../../../Hooks/useTranslation";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <img src="/assets/CASVI_Brand_Kit/PNG/CASVI_logo_transparent_2400px.png" alt="Casvi Software" />
      <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      <p>© {new Date().getFullYear()} Casvi Software. {t.footer.rights}</p>
    </footer>
  );
};

export default Footer;
